/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { AdminContract, AdminContractInterface } from "../AdminContract";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "NAME",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "STABILITY_POOL_NAME_BYTES",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "address",
        name: "_stabilityPoolImplementation",
        type: "address",
      },
      {
        internalType: "address",
        name: "_chainlinkOracle",
        type: "address",
      },
      {
        internalType: "address",
        name: "_chainlinkIndex",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "assignedToken",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_tokenPerWeekDistributed",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "redemptionLockInDay",
        type: "uint256",
      },
    ],
    name: "addNewCollateral",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract TransparentUpgradeableProxy",
        name: "proxy",
        type: "address",
      },
      {
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "changeProxyAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract TransparentUpgradeableProxy",
        name: "proxy",
        type: "address",
      },
    ],
    name: "getProxyAdmin",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract TransparentUpgradeableProxy",
        name: "proxy",
        type: "address",
      },
    ],
    name: "getProxyImplementation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_paramaters",
        type: "address",
      },
      {
        internalType: "address",
        name: "_stabilityPoolManager",
        type: "address",
      },
      {
        internalType: "address",
        name: "_borrowerOperationsAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_troveManagerAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_vstTokenAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_sortedTrovesAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "_communityIssuanceAddress",
        type: "address",
      },
    ],
    name: "setAddresses",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract TransparentUpgradeableProxy",
        name: "proxy",
        type: "address",
      },
      {
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "upgrade",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract TransparentUpgradeableProxy",
        name: "proxy",
        type: "address",
      },
      {
        internalType: "address",
        name: "implementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type AdminContractConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: AdminContractConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class AdminContract__factory extends ContractFactory {
  constructor(...args: AdminContractConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: string }
  ): Promise<AdminContract> {
    return super.deploy(overrides || {}) as Promise<AdminContract>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): AdminContract {
    return super.attach(address) as AdminContract;
  }
  override connect(signer: Signer): AdminContract__factory {
    return super.connect(signer) as AdminContract__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AdminContractInterface {
    return new utils.Interface(_abi) as AdminContractInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): AdminContract {
    return new Contract(address, _abi, signerOrProvider) as AdminContract;
  }
}
